@import '../../packages/shared/scss';

.contextual-icons {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  grid-template-rows: 1fr;
  gap: 0px 0px;
  grid-template-areas: "left center right";
  width: 100%;

  div.left-icons,
  div.right-icons {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  div.left-icons {
    grid-area: left;
    justify-self: start;
  }

  ::slotted(*) {
    grid-area: center;
    justify-self: center;
  }

  div.right-icons {
    grid-area: right;
    justify-self: end;
  }

  .icon-flex {
    display: flex;
    justify-content: center;
  }

  div.icon {
    position: relative;

    .shopping-cart-link,
    saved-items
    {
      position: relative;
      z-index: 2;
    }
    .badge-item-count {
      color: white;
      position: absolute;
      margin-left: 17px;
      margin-top: -6px;
      z-index: 12;
      font-size: 11px;
      line-height: 8px;
      width: 14px;
      height: 8px;
      padding: 4px 1px;
      text-align: center;
      border-radius: 10px;

      &.pill {
        margin-left: 23px;
        font-size: 10px;
        width: 20px;
        height: 7px;
      }

      &.light{
        background-color: $pds-theme-light-notification-error;
      }

      &.dark{
        background-color: $pds-theme-light-notification-error;
      }
    }
    padding: p-px-to-rem(6px);

    @include pds-media-query-min('m') {
      padding: p-px-to-rem(8px);
    }

    @include pds-media-query-min('xl') {
      padding: p-px-to-rem(12px);
    }
  }
}

.skeleton-container {
  flex: 1;
  display: flex;
  height: 28px;

  .burger-button-skeleton {
    margin-right: p-px-to-rem(6px);
    width: p-px-to-rem(24px);
    height: p-px-to-rem(24px);
    border-radius: 4px;
    @include pds-skeleton('light');

    @include pds-media-query-min('s') {
      width: p-px-to-rem(76px);
      height: p-px-to-rem(24px);
    }
  }

  .burger-button-skeleton-dark {
    margin-right: p-px-to-rem(6px);
    width: p-px-to-rem(24px);
    height: p-px-to-rem(24px);
    border-radius: 4px;
    @include pds-skeleton('dark');

    @include pds-media-query-min('s') {
      width: p-px-to-rem(76px);
      height: p-px-to-rem(24px);
    }
  }

  .pure-button-skeleton {
    width: p-px-to-rem(24px);
    height: p-px-to-rem(24px);
    border-radius: 4px;
    @include pds-skeleton('light');
  }

  .pure-button-skeleton-dark {
    width: p-px-to-rem(24px);
    height: p-px-to-rem(24px);
    border-radius: 4px;
    @include pds-skeleton('dark');
  }
}
